import SiafLiteApiRepository from "../../external/siafLiteApi";

class AtivoServicoService {
  constructor() {
    this.urlBase = "/faturamento/ativo-servicos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAllPaged(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAll() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/all`).get();
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }
}

export default AtivoServicoService;
